// components
import { Icon } from '@sdb/planning-ui';
import { Fragment } from 'react';

// styles
import {
  CustomIconContainer,
  StyledEntityInfoBox,
  StyledEntityTextTypography,
  StyledOverflowContainerBox,
  TextContainer,
  Title
} from '../../CalendarAppointment.styles';
import { StyledBoxFlexAlignCenterSpaceBetween } from 'components/shared/Box/Box.styles';

// import utils
import { themeExtension } from 'config/theme.extension';

// import types
import type { AppointmentCardInfoProps } from '../../CalendarAppointment.types';

const { palette } = themeExtension.custom!.constants.MRP;

const AppointmentContent = ({
  title,
  employeesOnAppointment,
  clientsOnAppointment,
  resourcesOnAppointment,
  workPlace,
  isOverflowing = false
}: AppointmentCardInfoProps) => {
  'use memo';

  if (isOverflowing) {
    // When content is overflowing, we only want to show the title in bold and hide the rest of the details in the overflow container.

    const content = [
      title,
      employeesOnAppointment,
      clientsOnAppointment,
      resourcesOnAppointment,
      workPlace
    ].filter(Boolean);

    return (
      <StyledOverflowContainerBox className="planeContent">
        {content.map((item, index) => (
          <Fragment key={index}>
            {index === 0 ? <b>{item}</b> : item}
            {index < content.length - 1 && '; '}
          </Fragment>
        ))}
      </StyledOverflowContainerBox>
    );
  }

  return (
    <>
      <StyledBoxFlexAlignCenterSpaceBetween>
        <TextContainer as="span" className="textContainer">
          <Title>{title}</Title>
        </TextContainer>
      </StyledBoxFlexAlignCenterSpaceBetween>

      <StyledEntityInfoBox>
        {employeesOnAppointment}
        {clientsOnAppointment}
        {resourcesOnAppointment}

        {!!workPlace && (
          <CustomIconContainer iconColor={palette.workplace}>
            <Icon type="house-chimney" />
            <StyledEntityTextTypography>{workPlace}</StyledEntityTextTypography>
          </CustomIconContainer>
        )}
      </StyledEntityInfoBox>
    </>
  );
};

export default AppointmentContent;
